import React, { Component, Fragment } from "react";
import { Checkbox } from "primereact/checkbox";
import CenterElement from "../../activity/activityComponent/CenterElement";
import $ from "jquery";
import ReactDOM from "react-dom";
import { RadioButton } from "primereact/radiobutton";

window.jQuery = $;

class AnsItemUI extends Component {
  // constructor() {
  //     super()
  //     this.ansItemUIRef = React.createRef()
  // }

  componentDidUpdate = () => {
    // let imgs =  $(ReactDOM.findDOMNode(this.ansItemUIRef.current)).children(".image-editor")
    //    $(this.ansItemUIRef.current).children(".image-editor").css("width","80px")
    $(".image-editor").css("width", "50%");
    $(".image-editor").css("height", "auto");
  };
  componentDidMount = () => {
    // let { ansContainer, ansModel, quizViewer } = this.props
    // let { quizViwerModel } = quizViewer.state
    // let { tfAnsArr, selectedStyle } = ansContainer

    // if (quizViwerModel.reviewMode) {
    //     // this.ansItemUIRef.current.style.backgroundColor = ansModel.getReviewColor().bgColor
    //     // this.ansItemUIRef.current.style.color = ansModel.getReviewColor().color
    //    // this.ansItemUIRef.className =  this.ansItemUIRef.className + ansModel.getReviewColor()
    // }

    $(".image-editor").css("width", "50%");
    $(".image-editor").css("height", "auto");
  };

  componentDidUpdate = () => {
    if (this.ansItemUIRef != null) window.x(this.ansItemUIRef);
  };

  componentWillReceiveProps = (props) => {
    //     let { ansContainer, ansModel, quizViewer } = props
    //     let { quizViwerModel } = quizViewer.state
    //     let { tfAnsArr, selectedStyle } = ansContainer
    //     if (quizViwerModel.reviewMode) {
    //         // this.ansItemUIRef.current.style.backgroundColor = ansModel.getReviewColor().bgColor
    //         // this.ansItemUIRef.current.style.color = ansModel.getReviewColor().color
    //        // this.ansItemUIRef.className =  this.ansItemUIRef.className + ansModel.getReviewColor()
    //     }
  };

  render = () => {
    let { ansContainer, ansModel, quizViewer } = this.props;
    let { quizViwerModel } = quizViewer.state;
    let { tfAnsArr, selectedStyle } = ansContainer;

    return (
      <Fragment>
        {
          !quizViwerModel.reviewMode ? (
            <div
              ref={(el) => (this.ansItemUIRef = el)}
              onClick={this.selectAns}
              className="ans-item"
              style={{
                direction: quizViwerModel.callbackData.dir,
                borderColor: "#CECAD3",

                backgroundColor: ansModel.isSelected ? "#e5dbff" : "#CECAD344",
              }}
            >
              <table
                style={{ width: "100%", height: "100%" }}
                className="table-mcq"
              >
                <tbody>
                  <tr>
                    <td
                      style={{
                        verticalAlign: "middle",
                        cursor: "pointer",
                      }}
                      dangerouslySetInnerHTML={{ __html: ansModel.ansTxt }}
                    ></td>
                  </tr>
                </tbody>
              </table>
            </div>
          ) : (
            <>
              <div
                ref={(el) => (this.ansItemUIRef = el)}
                className="ans-item"
                style={{
                  direction: quizViwerModel.callbackData.dir,
                  borderColor: ansModel.getReviewColor(),
                  background: ansModel.getReviewColor() + "44",
                }}
              >
                <table style={{ width: "100%", height: "100%" }}>
                  <tbody>
                    <tr>
                      <td
                        style={{ verticalAlign: "middle", textAlign: "center" }}
                        dangerouslySetInnerHTML={{ __html: ansModel.ansTxt }}
                      ></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </>
          )
          // <div ref={this.ansItemUIRef}
          //     className={"mcq-ans-btn btn-outline-secondary btn item-shape " + (ansModel.isSelected ? "active" : "") }
          //     style={{ width: "100%" }}//,border:"solid 1px"
          //     // style={(selectedStyle != null) ? selectedStyle[1].style : {}}
          //     onClick={this.selectAns}>

          //     <CenterElement
          //         content={ansModel.ansTxt}
          //         style={{ fontSiz: "16px" }}
          //         textAlign="center" />
          // </div>

          // <div ref={this.ansItemUIRef}
          // >
          //     <div className="p-grid">
          //         <div className="p-col-1">
          //             {

          //                 !ansContainer.multipleAnswers ?
          //                     <RadioButton style={{marginBottom: "6px"}} id={ansModel.ansIndex} value={ansModel.ansTxt} name="answer" onChange={this.selectAns} checked={ansModel.isSelected} />
          //                     :
          //                     <Checkbox onChange={this.selectAns} checked={ansModel.isSelected}></Checkbox>

          //             }
          //         </div>
          //         <div className="p-col-11">
          //             <div onClick={this.labelClicked} dangerouslySetInnerHTML={{ __html: ansModel.ansTxt }}></div>
          //         </div>
          //     </div>
          // </div>

          // :
          // <div ref={this.ansItemUIRef}
          // >
          //     <div className="p-grid">
          //         <div className="p-col-1">
          //              {
          //              !ansContainer.multipleAnswers ?

          //              <RadioButton style={{ backgroundColor: ansModel.getReviewColor() , marginBottom: "6px"}} disabled="disabled" id={ansModel.ansIndex} value={ansModel.ansTxt} name="answer" onChange={this.selectAns} checked={ansModel.isSelected} />
          //              :
          //              <Checkbox style={{ backgroundColor: ansModel.getReviewColor() }} disabled="disabled" checked={ansModel.isSelected}></Checkbox>

          //             }
          //                </div>
          //         <div className="p-col-10">
          //             <div dangerouslySetInnerHTML={{ __html: ansModel.ansTxt }} style={{ color: ansModel.getReviewColor() }}></div>
          //         </div>
          //         <div className="p-col-1">
          //             <i className="pi pi-times" style={{
          //                 display: (ansModel.isSelected && !ansModel.isRight) ? "inline-block" : "none", color: "red",
          //                 backgroundColor: "red",
          //                 color: "white",
          //                 borderRadius: "50%",
          //                 padding: "0.5rem",
          //             }} ></i>
          //         </div>
          //     </div>
          // </div>

          // <div ref={this.ansItemUIRef}
          //     className={"mcq-ans-btn btn-outline-secondary btn item-shape " + ansModel.getReviewColor()}
          //     style={{ width: "100%", border: "solid 1px" }}
          // // style={(selectedStyle != null) ? selectedStyle[1].style : {}}
          // >

          //     <CenterElement
          //         content={ansModel.ansTxt}
          //         style={{ fontSiz: "16px" }}
          //         textAlign="center" />
          // </div>
        }
      </Fragment>
    );
  };

  labelClicked = (e) => {
    let { ansModel } = this.props;
    //document.getElementById(ansModel.ansIndex).checked = true
    ansModel.isSelected = true;
    this.setState({});
    this.selectAns(e);
  };
  selectAns = (e) => {
    let { ansContainer, ansModel, quizViewer } = this.props;
    let { quizViwerModel } = quizViewer.state;
    let { tfAnsArr, selectedStyle } = ansContainer;

    let { projectPlugin } = quizViwerModel;

    if (!ansContainer.multipleAnswers) {
      tfAnsArr.map((item, index) => {
        item.isSelected = false;
      });
    }

    if (ansModel.isSelected) {
      //    this.ansItemUIRef.current.style.backgroundColor = "white"
      //  this.ansItemUIRef.current.className = this.ansItemUIRef.current.className.replace('active','')
      ansModel.isSelected = false;
    } else {
      // this.ansItemUIRef.current.style.backgroundColor = "lightgray"
      //  this.ansItemUIRef.current.className += " active"

      ansModel.isSelected = true;
    }

    quizViewer.setState({});
  };
}

export default AnsItemUI;
